import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { api } from "@/lib/api";

export default function Privacy() {
  const [params, setParams] = useSearchParams();
  const branch = (params.get("branch") || "DANDENONG").toUpperCase();
  const [data, setData] = useState(null);

  useEffect(() => {
    api
      .get("/public/privacy", { params: { branch } })
      .then(({ data: d }) => setData(d))
      .catch(() => setData(null));
  }, [branch]);

  if (!data) return null;

  return (
    <div className="min-h-screen bg-[#FBF8F2] px-5 py-10 sm:px-8" data-testid="privacy-page">
      <div className="print-area mx-auto max-w-3xl">
        <div className="flex items-center gap-3">
          <ShieldCheck className="h-6 w-6 text-[#C5A059]" />
          <p className="text-[11px] font-semibold uppercase tracking-[0.25em] text-[#B38F4E]">
            Privacy Policy
          </p>
        </div>
        <h1 className="mt-3 text-3xl font-bold sm:text-4xl">How we handle your information</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          {data.entity_name} · ABN {data.abn}
          <br />
          {data.address}
        </p>

        <div className="no-print mt-5 flex flex-wrap gap-2">
          {(data.branches || []).map((b) => (
            <button
              key={b}
              onClick={() => setParams({ branch: b })}
              className={`border px-3 py-1.5 text-xs uppercase tracking-wider transition-colors duration-150 ${
                b === data.branch
                  ? "border-[#0A0A0A] bg-[#0A0A0A] text-white"
                  : "border-border bg-white hover:bg-[#F4F1EA]"
              }`}
              data-testid={`privacy-branch-${b}`}
            >
              {b} store
            </button>
          ))}
          <button
            onClick={() => window.print()}
            className="border border-[#C5A059] px-3 py-1.5 text-xs uppercase tracking-wider transition-colors duration-150 hover:bg-white"
            data-testid="privacy-print"
          >
            Print
          </button>
        </div>

        <p className="mt-7 border-l-2 border-[#C5A059] bg-white p-4 text-sm leading-relaxed">
          {data.short_notice}
        </p>

        <div className="mt-8 space-y-8">
          {(data.sections || []).map(([title, points], i) => (
            <section key={i} data-testid={`privacy-section-${i}`}>
              <h2 className="border-b border-border pb-2 text-base font-bold uppercase tracking-wider md:text-lg">
                {title}
              </h2>
              <ul className="mt-3 space-y-2">
                {points.map((point, j) => (
                  <li key={j} className="flex gap-3 text-sm leading-relaxed">
                    <span className="mt-2 h-1.5 w-1.5 shrink-0 bg-[#C5A059]" />
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>

        <p className="mt-10 border-t border-border pt-5 text-xs text-muted-foreground">
          Questions about your information? Call {data.phone} or email {data.contact_email}.
        </p>
      </div>
    </div>
  );
}
